// Status → pill meta for the NEW-design (?new) tracking results only.
// Colors eye-dropped from the tracking mockup
// (new-design-other/tracking/…png): orange #FBB121 (booking/shipping),
// green #4AB868 (delivered), red #FF0024 (cancelled/returned), neutral grey
// for pending/unknown. Pill text is always white. The Thai/English status
// LABEL reuses the shared order-status maps in utility/trackingUtility (same
// text the old design shows) — this file only adds presentation (color).
import {
  orderStatusToTextMap,
  orderStatusToTextMapEng,
  interOrderStatusToTextMap,
  interOrderStatusToTextMapEng,
} from '../../utility/trackingUtility'

const PILL = {
  orange: '#FBB121',
  green: '#4AB868',
  red: '#FF0024',
  grey: '#90A4AE',
}

// order_status → pill color category (domestic + inter statuses combined).
const statusToPill = {
  // domestic
  wait: PILL.grey,
  booking: PILL.orange,
  shipping: PILL.orange,
  complete: PILL.green,
  pending_transfer: PILL.green,
  transferred: PILL.green,
  cancel: PILL.red,
  cancel_transfer: PILL.red,
  return: PILL.red,
  // inter
  waiting: PILL.grey,
  invalid: PILL.red,
  pending: PILL.red,
}

const getStatusMeta = (status, deliveryType, lang = 'th') => {
  const isInter = deliveryType === 'inter'
  const th = isInter ? interOrderStatusToTextMap : orderStatusToTextMap
  const en = isInter ? interOrderStatusToTextMapEng : orderStatusToTextMapEng
  const map = lang === 'th' ? th : en
  return {
    text: map[status] || status || '-',
    pillBg: statusToPill[status] || PILL.grey,
  }
}

export { getStatusMeta, PILL }
export default getStatusMeta
